import { TableButton } from '@ipfabric/ui-components/TableButton/TableButton';
import { toLabelDataTestIdSuffix } from '../../../shared/toLabelDataTestIdSuffix';

type SelectedLabelsListProps = {
  labels: string[];
  onRemove: (label: string) => void;
};

export const SelectedLabelsList = ({
  labels,
  onRemove,
}: SelectedLabelsListProps) => {
  if (labels.length === 0) {
    return null;
  }

  return (
    <div className='flex flex-col gap-2xs'>
      {labels.map((label) => (
        <div className='flex w-full items-center gap-sm' key={label}>
          <span className='min-w-0 flex-1 text-sm'>{label}</span>
          <TableButton
            accent='negative'
            dataTestId={`assign-labels-label-chip-remove-${toLabelDataTestIdSuffix(label)}`}
            icon='fa-trash-can'
            onClick={() => onRemove(label)}
            type='button'
            variant='plain'
          />
        </div>
      ))}
    </div>
  );
};
